<template>
  <main id="ComponentGallery" ref="ComponentGallery">
    <div>
      <component-gallery-header />
      <section id="component-gallery-content" ref="Content" role="main">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </section>
    </div>
  </main>
</template>
<script>
import ComponentGalleryHeader from "./components/partials/ComponentGalleryHeader.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ComponentGalleryHeader: ComponentGalleryHeader,
  },
  created() {
    this.$store.dispatch("initPortletId", this.$root.portletId);
  },
  computed: {
    ...mapGetters(["streetViewStatus"]),
  },
  mounted() {
    if (themeDisplay.getLanguageId()) {
      this.setLang(themeDisplay.getLanguageId());
    }
    this.initComponentGallerySize();
    this.hideHeader();
    // recalculate app size, if screen is resized:
    window.addEventListener("resize", this.initComponentGallerySize);
    window.scrollTo({ top: 0 });

    window.addEventListener("keyup", (e) => {
      // Listen for ESCAPE clicks
      if (e.key.toLowerCase() === "escape") {
        this.setEscClicked(true);
      }
    });
  },
  methods: {
    ...mapActions(["setLang", "setEscClicked"]),
    hideHeader() {
      document.querySelector("#banner").style.display = "none";
    },
    initComponentGallerySize() {
      const banner = this.$refs.ComponentGallery;
      const content = this.$refs.Content;
      let qaBanner = 0;
      if (document.querySelector("#ControlMenu")) {
        qaBanner = document.querySelector("#ControlMenu").offsetHeight;
      }

      banner.style.height = `${window.visualViewport.height}px`;
      content.style.height = `${window.visualViewport.height -
        document.querySelector("#component-gallery-header").offsetHeight -
        qaBanner + 50
        }px`;
    },
  },
  watch: {
    streetViewStatus: {
      handler(newValue) {
        this.initComponentGallerySize();
      },
    },
  },
};
</script>
<style lang="scss">
#ComponentGallery {
  box-sizing: border-box;
  padding-left: 0;
  padding-right: 0;
}

#component-gallery-content {
  overflow: auto;
  margin-bottom: 50px;
}

.dark-blue {
  background-color: #002f6c;
}

.light-blue {
  background-color: #00a9e0;
}

.color-dark-blue {
  color: #002f6c;
}

.color-light-blue {
  color: #00a9e0;
}

.color-white {
  color: white;
}

.top-frame #content .listing-layout.layout-wide {
  padding-top: 0px;
  padding-right: 0px;
}
</style>